import { Injectable, OnDestroy } from '@angular/core'
import { ApplicationService } from '@idp-education/ors-test-taker-bff-client-v1'
import { DashboardResponse, ApplicationService as ApplicationServiceV2, DashboardItem } from '@idp-education/ors-test-taker-bff-client-v2'
import { BehaviorSubject, Observable, Subscription } from 'rxjs'
import { pluck, map, defaultIfEmpty, share, tap, switchMap } from 'rxjs/operators'
import { AuthService } from '../../common/services/auth.service'
import * as uuid from 'uuid'
import { CommonService } from '../../common/services/common.service'
import { environment } from 'src/environments/environment'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    private appRequest$: BehaviorSubject<DashboardResponse | any> = new BehaviorSubject<DashboardResponse | any>(null)
    public applicationRequest: Observable<DashboardResponse | any> = this.appRequest$.asObservable()
    private fetchApplication$!: Observable<DashboardResponse> | undefined
    private forceFetch = false
    private _lastFetchTime: number = 0
    private readonly expireTime = environment.requestExpireTime.dashboard

    public get lastFetchTime (): number {
        return this._lastFetchTime
    }
    private sub = new Subscription()
    enableDashboardV2 = false
    private dashboardApplicationsSubject = new BehaviorSubject<DashboardResponse | null>(null)
    public dashboardApplications$ = this.dashboardApplicationsSubject.asObservable()
    headerData = new HttpHeaders({
    'Content-Type': 'application/json'
})

    constructor (
        private applicationService: ApplicationService,
        private authenticationService: AuthService,
        private applicationServiceV2: ApplicationServiceV2,
        private commonService: CommonService,
        private http: HttpClient
    ) {

        // this.sub.add(this.store?.select(st => st.userStore)?.subscribe(data => {
        //     if (data?.isLogOut) {
        //         this.clear();
        //     }
        // }));
        // this.sub.add(this.store?.select(appState => appState?.globalStore?.enableDashboardV2)?.subscribe(enableDashboardV2 => {
        //     if (enableDashboardV2) {
        //         this.enableDashboardV2 = enableDashboardV2;
        //         localStorage.setItem('enableDashboardV2', JSON.stringify(enableDashboardV2));
        //     }
        // }));
    }

    // isThereResultAvailable(): Observable<boolean> {
    //     return this.getAllDashboardApplications().pipe(map<DashboardResponse, boolean>(app => {
    //         if (Array.isArray(app?.pastTests)) {
    //             return !!app.pastTests.filter(i => i.status === 'RESULTS_AVAILABLE' || i.status === 'EOR_IN_PROGRESS'
    //                 || i.status === 'EOR_COMPLETED').length;
    //         } else {
    //             return false;
    //         }
    //     }));

    // }
    // isTherePastTests(): Observable<boolean> {
    //     return this.getAllDashboardApplications().pipe(map<DashboardResponse, boolean>(app => {
    //         if (Array.isArray(app?.pastTests)) {
    //             return !!app.pastTests.length;
    //         } else {
    //             return false;
    //         }
    //     }));
    // }

    // getCancelledTests(): Observable<DashboardItem[]> {
    //     return this.getAllDashboardApplications().pipe(map<DashboardResponse, DashboardItem[]>(app =>
    //         app?.pastTests?.filter(i => i.status === 'CANCELLED')
    //     ), defaultIfEmpty([]));
    // }
    // clear() {
    //     this.sub.unsubscribe();
    //     this.appRequest$?.next(null);
    //     this.appRequest$ = null;
    //     this.applicationRequest = null;
    //     this.store.dispatch(setDashboard(null));
    //     localStorage.removeItem('enableDashboardV2');
    // }
    // getLastResultAvailable(): Observable<DashboardItem> {
    //     return this.getAllResultAvailable().pipe(
    //         map(items => {
    //             // Since the dashboard returns past test with results sorted from backend as part of 23396
    //             // No need for sorting in the UI.
    //             return items[0]
    //         })
    //     )
    // }

    // hasAnyUnpaid (): Observable<boolean> {
    //     return this.getUpcomingTests().pipe(
    //         map(items => items.filter(i => i.status === 'UNPAID')),
    //         map(data => !!data.length))
    // }
    // getFirstUnpaidApplicationId (): Observable<DashboardItem> {
    //     return this.getAllDashboardApplications().pipe(
    //         pluck('upcomingTests'),
    //         map(items => items.filter((i: any) => i.status === 'UNPAID')),
    //         map(data => data[0]))
    // }

    // newwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww
    getAllResultAvailable (): Observable<DashboardItem[]> {
        return this.getPastTests().pipe(
            map((items) => items.filter(i => i.status === 'RESULTS_AVAILABLE' || i.status === 'EOR_IN_PROGRESS' || i.status === 'EOR_COMPLETED')))
    }

    getPastTests (): Observable<DashboardItem[]> {
        return this.getAllDashboardApplications().pipe(map<DashboardResponse, DashboardItem[]>(app => app?.pastTests))
    }

    isThereUpcomingTests (): Observable<boolean> {
        return this.getAllDashboardApplications().pipe(map<DashboardResponse, boolean>(app => {
            if (Array.isArray(app?.upcomingTests) && app?.upcomingTests.length) {
                return !!app.upcomingTests.length
            } else {
                return false
            }
        }))
    }

    getAllDashboardApplications (force = false): Observable<DashboardResponse> {
        this.forceFetch = force
        const isTheLastReqExpired = () => {
            return new Date().getTime() - this.lastFetchTime > this.expireTime
        }
        if (force || (!force && (!this.appRequest$?.value || isTheLastReqExpired()))) {
            if (!this.fetchApplication$) {
                this.fetchApplication$ = this.fetchApplications()
            }
            return this.fetchApplication$
        } else if (this.appRequest$?.value && !this.applicationRequest) {
            this.applicationRequest = this.appRequest$?.asObservable()
        }
        this.fetchApplication$ = undefined
        return this.applicationRequest
    }

    private fetchApplications (): Observable<DashboardResponse> {
        return this.authenticationService.checkToken().pipe(
            switchMap(() => {
                const getDashBoardItem = localStorage.getItem('enableDashboardV2')
                this.enableDashboardV2 = (getDashBoardItem === 'true')
                return this.enableDashboardV2 ? this.applicationServiceV2.getApplicationsDashboardV2(this.correlationId()) : this.applicationService.getApplicationsDashboard(this.correlationId())
            }), tap(data => {
                this.appRequest$?.next(data)
                this._lastFetchTime = new Date().getTime()
            }), share()
        )
    }

    correlationId () {
        return location.href.endsWith('my-account') || location.href.endsWith('my-tests') ? uuid.v4() : this.commonService?.getUserUuid()
    }

    getUpcomingTests (): Observable<any> {
        return this.getAllDashboardApplications()
    }

    setDashboard (applications: DashboardResponse | null): void {
        this.dashboardApplicationsSubject.next(applications)
      }

    getDashboard (userCreatedDate: any) {
       userCreatedDate = { userCreatedDate }
       const minimalHeaders = new HttpHeaders()
       return this.http.post<any>(environment.nextBestActionApi, userCreatedDate, { headers: minimalHeaders })
    }

    getStudentEssentials (prodName: string, country: string): Observable<any> {
        const countryData = { testType: prodName, country }
        return this.http.post<any>(environment.studentEssentialApi, countryData, { headers: this.headerData })
    }
}
